import { NavLink, useRouteLoaderData } from "react-router-dom";
import classes from "./LeftBar.module.css";
import Hamburger from "./HamburgerLeftBar";
import { useState } from "react";
import {
  IoQrCodeSharp,
  IoBookmarkSharp,
  IoBulb,
  IoCog,
  IoHome,
  IoAccessibility,
  IoPizza,
  IoDocumentTextSharp,
  IoBook,
  IoWine 

} from "react-icons/io5";

export default function LeftBar() {
  const [HamburgerPressed, setHamburgerPressed] = useState(false);
  const isAuthenticated = useRouteLoaderData("root");
  const role = localStorage.getItem("role");

  if (!isAuthenticated) return null;

  function HamburgerHandler() {
    console.log("i m clicked");
    setHamburgerPressed((prev) => {
      console.log(prev);
      return !prev;
    });
  }

  return (
    <>
      <div
        className={` ${classes.leftBarContainer} ${
          HamburgerPressed
            ? classes.barContainerWide
            : classes.barContainerNarrow
        }
        `}
      >
        <div className={classes.hamburgerContainer}>
          <Hamburger clickHandler={HamburgerHandler} />
        </div>
        <div
          onClick={() => {
            setHamburgerPressed(false);
          }}
        >
          <nav>
            <ul className={classes.list}>
              <li>
                <NavLink
                  to="/"
                  className={({ isActive }) =>
                    isActive ? classes.active : undefined
                  }
                  end
                >
                  {HamburgerPressed ? (
                    <>
                      
                      <div className={classes.iconBox}>
                        {" "}
                        <IoHome />
                      </div>{" "}
                      Home
                     
                    </>
                  ) : (
                    <div className={classes.iconBoxContainer}>
                      <div className={classes.iconBox}>
                        <IoHome />
                      </div>
                    </div>
                  )}
                </NavLink>
              </li>
              {/* <a href="/qrcode">QR Code</a> */}
              {role !== "hq" && (
              <li>
                <NavLink
                  to="/qrcode"
                  className={({ isActive }) =>
                    isActive ? classes.active : undefined
                  }
                >
                  {HamburgerPressed ? (
                    <>
                      <div className={classes.iconBox}>
                        {" "}
                        <IoQrCodeSharp />
                      </div>{" "}
                      QR Code
                    </>
                  ) : (
                    <div className={classes.iconBoxContainer}>
                      <div className={classes.iconBox}>
                        {" "}
                        <IoQrCodeSharp />
                      </div>{" "}
                    </div>
                  )}
                </NavLink>
              </li>
              )}
              <li>
                <NavLink
                  to="/myprofile"
                  className={({ isActive }) =>
                    isActive ? classes.active : undefined
                  }
                >
                  {HamburgerPressed ? (
                    <>
                      <div className={classes.iconBox}>
                        {" "}
                        <IoCog />
                      </div>{" "}
                      Profile
                    </>
                  ) : (
                    <div className={classes.iconBoxContainer}>
                      <div className={classes.iconBox}>
                        {" "}
                        <IoCog />
                      </div>
                    </div>
                  )}
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/questiondetail"
                  className={({ isActive }) =>
                    isActive ? classes.active : undefined
                  }
                >
                  {HamburgerPressed ? (
                    <>
                      <div className={classes.iconBox}>
                        {" "}
                        <IoBulb />
                      </div>{" "}
                      Questions
                    </>
                  ) : (
                    <div className={classes.iconBoxContainer}>
                      <div className={classes.iconBox}>
                        {" "}
                        <IoBulb />
                      </div>
                    </div>
                  )}
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/SavedFeedbacks"
                  className={({ isActive }) =>
                    isActive ? classes.active : undefined
                  }
                >
                  {HamburgerPressed ? (
                    <>
                      <div className={classes.iconBox}>
                        {" "}
                        <IoBookmarkSharp />
                      </div>{" "}
                      Saved Forms
                    </>
                  ) : (
                    <div className={classes.iconBoxContainer}>
                      <div className={classes.iconBox}>
                        {" "}
                        <IoBookmarkSharp />
                      </div>
                    </div>
                  )}
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/staff"
                  className={({ isActive }) =>
                    isActive ? classes.active : undefined
                  }
                >
                  {HamburgerPressed ? (
                    <>
                      <div className={classes.iconBox}>
                        {" "}
                        <IoAccessibility />
                      </div>{" "}
                      Staff Review
                    </>
                  ) : (
                    <div className={classes.iconBoxContainer}>
                      <div className={classes.iconBox}>
                        {" "}
                        <IoAccessibility />
                      </div>
                    </div>
                  )}
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/food"
                  className={({ isActive }) =>
                    isActive ? classes.active : undefined
                  }
                >
                  {HamburgerPressed ? (
                    <>
                      <div className={classes.iconBox}>
                        {" "}
                        <IoPizza />
                      </div>{" "}
                      Food Section
                    </>
                  ) : (
                    <div className={classes.iconBoxContainer}>
                      <div className={classes.iconBox}>
                        {" "}
                        <IoPizza />
                      </div>
                    </div>
                  )}
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/report"
                  className={({ isActive }) =>
                    isActive ? classes.active : undefined
                  }
                >
                  {HamburgerPressed ? (
                    <>
                      <div className={classes.iconBox}>
                        {" "}
                        <IoDocumentTextSharp />
                      </div>{" "}
                      Reporting
                    </>
                  ) : (
                    <div className={classes.iconBoxContainer}>
                      <div className={classes.iconBox}>
                        {" "}
                        <IoDocumentTextSharp />
                      </div>
                    </div>
                  )}
                </NavLink>
              </li>
               <li>
                <NavLink
                  to="/summary"
                  className={({ isActive }) =>
                    isActive ? classes.active : undefined
                  }
                >
                  {HamburgerPressed ? (
                    <>
                      <div className={classes.iconBox}>
                        {" "}
                        <IoBook />
                      </div>{" "}
                      AI Summary
                    </>
                  ) : (
                    <div className={classes.iconBoxContainer}>
                      <div className={classes.iconBox}>
                        {" "}
                        <IoBook/>
                      </div>
                    </div>
                  )}
                </NavLink>
              </li>
              {role !== "hq" && (
              <li>
                <NavLink
                  to="/loyaltytracker"
                  className={({ isActive }) =>
                    isActive ? classes.active : undefined
                  }
                >
                  {HamburgerPressed ? (
                    <>
                      <div className={classes.iconBox}>
                        <IoWine />
                      </div>
                      Loyalty Tracker
                    </>
                  ) : (
                    <div className={classes.iconBoxContainer}>
                      <div className={classes.iconBox}>
                        <IoWine />
                      </div>
                    </div>
                  )}
                </NavLink>
              </li>
              )}
            </ul>
          </nav>
        </div>
      </div>
    </>
  );
}
